import React from 'react';
import style from '../Styles/NewFooter.module.css';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className={style.footer} style={{ background: `url(./images/pic1.jpg) center/cover no-repeat` }}>
            <div className={style.container}>
                <div className={style.footerSectionAbout}>
                    <h3>About Us</h3>
                    <p>
                        Discover top movies tailored to your taste—explore trending films and hidden gems on our recommendation platform!
                    </p>
                </div>

                <div className={style.footerSectionLinks}>
                    <h3>Quick Links</h3>
                    <ul>
                        <li><Link className={style.all} to="/">Home</Link></li>
                        <li><HashLink className={style.all} to="/#mostPopular">Most Popular</HashLink></li>
                        <li><HashLink className={style.all} to="/#topRated">Top Rated</HashLink></li>
                        <li><Link className={style.all} to="/Blogs">Blogs</Link></li>
                    </ul>
                </div>

                <div className={style.footerSectionContact}>
                    <h3>Contact Us</h3>
                    <div className={style.socials}>
                        <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook className={style.socialIcon} /></a>
                        <a href="https://www.twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter className={style.socialIcon} /></a>
                        <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram className={style.socialIcon} /></a>
                        <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn className={style.socialIcon} /></a>
                        <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube className={style.socialIcon} /></a>
                    </div>
                </div>

            </div>
            <div className={style.footerBottom}>
                © 2025 Cineva | All Rights Reserved |
            </div>

        </footer>
    );
};

export default Footer;
